export default __webpack_public_path__ + "static/media/business-class.cae8c27b.png";